<template>
  <modal-default
    ref="modal"
    title="Upload Email Signature Image"
    :short-circuit-close="true"
    @close="cancelAndClose"
  >
    <b-field
      class="file is-primary"
      :class="{'has-name': !!file}"
    >
      <b-upload
        v-model="file"
        class="file-label"
      >
        <span class="file-cta">
          <icon-default
            class="file-icon"
            icon="upload"
            size="is-small"
          ></icon-default>
          <span class="file-label">{{ file ? 'Change' : 'Choose' }} Image</span>
        </span>

        <span
          class="file-name"
          v-if="file"
        >{{ file.name }}</span>
      </b-upload>

      <form-validation-errors :validation-errors="validationErrors.file"></form-validation-errors>
      <form-validation-errors :validation-errors="validationErrors.file_name"></form-validation-errors>
    <br>
    </b-field>

    <template v-slot:footer>
      <button-default
        :disabled="!file"
        :async-click="uploadImage"
      >Insert Image</button-default>
    </template>
  </modal-default>
</template>

<script>
import ModalBase from "../../../modal/ModalBase";
import {destroyModal} from "../../../../services/modals";
import FormValidationErrors from "../../FormValidationErrors";

export default {
  name: "EmailSignatureModal",
  components: {FormValidationErrors, ModalBase},
  props: {
    user: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      isLoading: true,
      isUploading: false,
      file: null,
      validationErrors: {},
    }
  },
  mounted() {
    this.$refs.modal.open();
  },
  computed: {
    fileName() {
      let parts = this.file.name.split('.');
      parts.pop(); // Removing the doc type section
      return (this.file) ? encodeURI(parts.join('.').replace(/ /g, '-')) : null;
    }
  },
  methods: {
    uploadImage() {
      this.isUploading = true;
      return this.$api.users.uploadEmailSignature(this.user.id, this.file, this.fileName, this.validationErrors).then((response) => {
        this.uploadedEmailSignature(response.data.image_url);
      });
    },
    uploadedEmailSignature(emailSignatureUrl) {
      this.$emit('uploadedEmailSignature', emailSignatureUrl);
      destroyModal(this.$refs.modal);
    },
    cancelAndClose() {
      destroyModal(this.$refs.modal);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables/variables";

.file-cta,
.file-label {
  font-size: 0.75rem;
}

.snippet_item {
  display: block;
  margin-bottom: 8px;
  font-size: 1rem;
  font-family: $sans-family;
  color: $secondary;

  &:hover {
    color: $primary;
  }
}
</style>
